import { ColorTheme, shadows, breakpoints } from "./abstract/_variables";
import { respondTo } from "./abstract/_mixins";

export const Theme = {
  colors: { ...ColorTheme },
  shadows: { ...shadows },
  respondTo: { ...respondTo },
  breakpoints: { ...breakpoints },
};
